// Authentication utility functions

const TOKEN_KEY = 'wg_auth_token';
const QUOTE_NAME_KEY = 'QUOTE_NAME';

export function persistPortalToken(token) {
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
}

export function getToken() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');
  const urlQuoteName = urlParams.get('quote_name');

  if (urlQuoteName) sessionStorage.setItem(QUOTE_NAME_KEY, urlQuoteName);
  if (urlToken) sessionStorage.setItem(TOKEN_KEY, urlToken);

  return {
    token: urlToken ?? sessionStorage.getItem(TOKEN_KEY),
    quoteName: urlQuoteName ?? sessionStorage.getItem(QUOTE_NAME_KEY),
  };
}

export function hasValidToken() {
  const { token } = getToken();
  return !!token;
}

export function getQuoteName() {
  return getToken().quoteName;
}

export function getQuoteNameNormalized() {
  return getToken().quoteName;
}

export function hasValidQuoteName() {
  return !!getQuoteName();
}